jQuery(document).ready(function ($) {

    var scrollcheck = throttle(function () {
        var s = $(document).scrollTop();
        // max / min for top-bar
        if (s > 0) {
            $('.top-bar').addClass('min');
        } else {
            $('.top-bar').removeClass('min');
        }
        // show / hide top of page link
        if (s > 800) {
            $('#to-top-of-page').removeClass('min');
        } else {
            $('#to-top-of-page').addClass('min');
        }

        check_viewport(s, false);
    }, 5);

    $(window).scroll(scrollcheck);

    function throttle(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            if (!timeout) timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }


    function check_viewport(s, bypass) {
        $elements = (bypass) ? $('.vpanim-out:not(.bypass-init)') : $('.vpanim-out');
        $elements.each(function () {
            // if item has class of vpnaim-full, only animate when the whole item is in the viewport (unless it's bigger than the vp in which case will trigger at top of page
            var itemOffset = 0;
            if ($(this).attr('data-vpanim-full')) {
                itemOffset = $(this).height();
            }
            if ($(this).offset().top - (s + $(window).height() - itemOffset) < 0) {
                $(this).removeClass('vpanim-out');
            }
        });
    }


    $('[data-vpanim]').addClass('vpanim-out');
    $('[data-vpanim-delay]').each(function () {
        var d = $(this).attr('data-vpanim-delay');
        $(this).css({"transition-delay": d});
    });

    check_viewport($(document).scrollTop(), true);


    $('#wp-admin-bar-toggle-admin-bar').on('click', function () {
        $('#wpadminbar').toggleClass('pulled-down');
    });


    // Form reset button
    $('[data-reset-form]').on('click', function (e) {
        e.preventDefault();
        $(this).parentsUntil('form').parent().find('input[type=text][data-can-reset]').val('');
        $(this).parentsUntil('form').parent().find('input[type=number][data-can-reset]').val('');
        $(this).parentsUntil('form').parent().find('input[type=checkbox][data-can-reset]').prop('checked', false);
        $(this).parentsUntil('form').parent().find('select[data-can-reset]').each(function (e) {
            if ($(this).attr('multiple')) {
                $(this).find('option:selected').prop('selected', false).trigger('change');
            } else {
                $(this).find('option:first').prop('selected', true).trigger('change');
            }
        });
    });


    // Lightcase lightbox setup
    //$('a[data-rel^=lightcase]').lightcase();


    $('[data-fancybox]').fancybox({
        thumbs : {
            autoStart : true,
            axis      : 'x'
        },
        mobile : {
            thumbs : {
                autoStart: false
            }
        }
    });

    $('.flexible-content-reveal-button').on('click', function(){
        let content = $(this).prev().html();
        $('#flexible-content-reveal-modal .insert-content').html(content);
        $('#flexible-content-reveal-modal').foundation('open');
    });

    $('#dealer-region-select').on('change', function(){
       window.location = $(this).val();
    });

});


(function($) {

    /*
    *  new_map
    *
    *  This function will render a Google Map onto the selected jQuery element
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	4.3.0
    *
    *  @param	$el (jQuery element)
    *  @return	n/a
    */

    function new_map( $el ) {

        // var
        var $markers = $el.find('.marker');


        // vars
        var args = {
            zoom		: 16,
            center		: new google.maps.LatLng(0, 0),
            mapTypeId	: google.maps.MapTypeId.ROADMAP
        };


        // create map
        var map = new google.maps.Map( $el[0], args);


        // add a markers reference
        map.markers = [];


        // add markers
        $markers.each(function(){

            add_marker( $(this), map );

        });


        // center map
        center_map( map );


        // return
        return map;

    }

    /*
    *  add_marker
    *
    *  This function will add a marker to the selected Google Map
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	4.3.0
    *
    *  @param	$marker (jQuery element)
    *  @param	map (Google Map object)
    *  @return	n/a
    */

    function add_marker( $marker, map ) {

        // var
        var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

        // create marker
        var marker = new google.maps.Marker({
            position	: latlng,
            map			: map
        });

        // add to array
        map.markers.push( marker );

        // if marker contains HTML, add it to an infoWindow
        if( $marker.html() )
        {
            // create info window
            var infowindow = new google.maps.InfoWindow({
                content		: $marker.html()
            });

            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function() {

                infowindow.open( map, marker );

            });
        }

    }

    /*
    *  center_map
    *
    *  This function will center the map, showing all markers attached to this map
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	4.3.0
    *
    *  @param	map (Google Map object)
    *  @return	n/a
    */

    function center_map( map ) {

        // vars
        var bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        $.each( map.markers, function( i, marker ){

            var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

            bounds.extend( latlng );

        });

        // only 1 marker?
        if( map.markers.length == 1 )
        {
            // set center of map
            map.setCenter( bounds.getCenter() );
            map.setZoom( 16 );
        }
        else
        {
            // fit to bounds
            map.fitBounds( bounds );
        }

    }

    /*
    *  document ready
    *
    *  This function will render each map when the document is ready (page has loaded)
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	5.0.0
    *
    *  @param	n/a
    *  @return	n/a
    */
// global var
    var map = null;

    $(document).ready(function(){

        $('.acf-map').each(function(){

            // create map
            map = new_map( $(this) );

        });

    });

})(jQuery);